import { get } from "lodash";
import { useMemo } from "react";
import { useTriviaContext, type TriviaHelp } from "../context-trivia";
import { TriviaButtonHelp } from "../TriviaButtonHelp/TriviaButtonHelp";

type TriviaQuestionHelpProps = {
  onHelpClicked: (help: TriviaHelp) => void;
};

export function TriviaQuestionHelp({ onHelpClicked }: TriviaQuestionHelpProps) {
  const { screen } = useTriviaContext();

  const backgroundColor = useMemo<string>(
    () => get(screen, "flyout.post.customData.buttonColorBackground"),
    [screen],
  );

  return (
    <div
      className="flex flex-row justify-center items-center rounded-2xl py-8"
      style={{ backgroundColor }}
    >
      <div className="flex flex-col grow justify-center items-center">
        <TriviaButtonHelp
          help="fityfity"
          icon="home"
          text="50/50"
          onHandleMouse={onHelpClicked}
        />
      </div>
      <div className="flex grow justify-center items-center">
        <TriviaButtonHelp
          help="poll"
          icon="chart"
          text="Poll"
          onHandleMouse={onHelpClicked}
        />
      </div>
      <div className="flex grow justify-center items-center">
        <TriviaButtonHelp
          help="ai"
          icon="chat"
          text="Ask AI"
          onHandleMouse={onHelpClicked}
        />
      </div>
    </div>
  );
}
